module.exports = __webpack_public_path__ + "static/media/gallery5.3a0e3939.jpg";